import request from '@/api/request'
export default{
    getClasses:params=>request.get('/classes/getClasses',{params}),
    getClassesBySubjectsId:subjectsId=>request.get('/classes/getClassesBySubjectsId',{params:{subjectsId}})
}